export const commonCss = {
  blue: "rgb(0, 86, 151)",
  white: "white",
  darkBlue: "rgb(0, 74, 131)",
  orange: "#FF9800",
  yellow: "#ffbe0b",
  iconYellow: "#cfa42e",
  red: "#FD0000",
  green: "#388e3c",
  // Card colors
  cardNewColor: "#25c2e3",
  cardProgressColor: "#ffbe0b",
  cardRejectedColor: "#ff5c75",
  cardApprovedColor: "#43d39e",
  cardCancelColor: "#D100D1",
  cardCloseColor: "#FBBF77",
  inputBorderRadius: "13px",
  inputBorderColor: "#747373",
  labelPadding: 0.5,
  labelFontWeight: "500",
  labelInputColor: "black",
  inputBackgroundColor: "white",
  buttonBorderRadius: "13px",
  buttonTextColor: "white",
  mainLabelHeading: "bold",
  normalSentenceWeight: "bold",
  normalSenternceColor: "black",
  outSideSentenceColor: "white",
  paperBorderRadius: "10px",
  titleFontSize: "1.5rem",
  titleFontWeight: 600,
  titleColor: "#FD0000",
  readOnlyBGColor: "rgba(0, 0, 0, 0.05)",
  backgroundColor: "rgb(240, 235, 248)",
};

// export const commonCss={
//     green:"rgb(0, 86, 151)",
//     red:"#FD0000",
//     shadeGreen:"white",
//     shadeRed:"white",
//     yellow:"#ffbe0b",
//     shadeLinearGradient:"linear-gradient(to right, white, white)",
//     normalLinearGradient:"linear-gradient(to right, rgb(0, 86, 151), #FD0000)",
//     inputBorderRadius:"13px",
//     inputBorderColor:"#747373",
//     labelPadding:0.5,
//     labelFontWeight:"500",
//     labelInputColor:"black",
//     inputBackgroundColor:"white",
//     buttonBorderRadius:"13px",
//     buttonTextColor:"white",
//     mainLabelHeading:"bold",
//     normalSentenceWeight:"bold",
//     normalSenternceColor:"black",
//     outSideSentenceColor:"white",
//     paperBorderRadius:"10px",
//     titleFontSize:"1.5rem",
//     titleFontWeight:600,
//     titleColor:"#FD0000",
//     readOnlyBGColor:"white"
// }
